import React, { useEffect, useState } from 'react'
import { ModalFooter } from '../../../../../../../../common/components/wizard/ModalFooter'
import { ModalContentContainer } from '../../../../../../../../common/components/wizard/ModalContentContainer'
import { ModalController } from '../../../../../../../../common/components/wizard/ModalController'
import { Wizard } from '../../../../../../../../common/components/wizard/Wizard'
import { WizardStep } from '../../../../../../../../common/components/wizard/WizardStep'
import { ReviewReport } from 'common/types/ReviewReport'
import { useLocation } from 'react-router-dom'
import { ModalHeader } from 'cwp-components/CWP Sections/components/ModalHeader'
import { ReportDetails, ReportDetailsFields } from './ReportDetails'
import { useReportReview } from '../useReportReview'

type ReportReviewWizardProps = {
  isOpen: boolean
  handleClose: () => void
  reviewType: string
  reviewId: string
}

export const ReportReviewWizard = ({
  isOpen,
  handleClose,
  reviewType,
  reviewId,
}: ReportReviewWizardProps) => {
  const [status, setStatus] = useState<string>('')
  const { reportReview } = useReportReview()
  const location = useLocation()
  const profileUrl = window.location.origin + location.pathname
  const [reportDetails, setReportDetails] =
    useState<ReportDetailsFields | null>(null)

  const NUMBER_OF_STEPS = 3

  useEffect(() => {
    if (!isOpen) {
      setReportDetails(null)
    }
  }, [isOpen])

  const handleStep2Submit = async (values: ReportDetailsFields) => {
    setStatus('')
    setReportDetails(values)
    const data = {
      first_name: values.firstName,
      last_name: values.lastName,
      email_address: values.emailAddress,
      phone_number: values.phoneNumber,
      message: values.message,
      profile_url: profileUrl,
      category: 'report_profile_content',
      [`${reviewType}_review`]: reviewId,
    } as ReviewReport

    try {
      await reportReview(data)
      setStatus('Your report has been submitted')
    } catch (error) {
      setStatus('There was an error submitting the report')
      console.error(error)
    }
  }

  const onClose = () => {
    setStatus('')
    handleClose()
  }
  return (
    <Wizard totalSteps={NUMBER_OF_STEPS} isWizardOpen={isOpen}>
      <ModalController
        isModalOpen={isOpen}
        onClose={onClose}
        widths='w-[340px] md:w-[574px]'
      >
        <ModalHeader headerText='Report review' onClose={onClose} />
        <ModalContentContainer>
          <WizardStep step={1}>
            <ReportDetails
              initialValues={reportDetails}
              saveValues={setReportDetails}
              handleStep2Submit={handleStep2Submit}
            />
          </WizardStep>
          <WizardStep step={2}>
            <h5 className='mt-4 flex justify-center text-sm md:text-base text-black font-normal md:font-medium'>
              {status}
            </h5>
            <ModalFooter
              backButtonHide={!status.includes('error')}
              handleClose={onClose}
              forwardButtonText='Finish'
            />
          </WizardStep>
        </ModalContentContainer>
      </ModalController>
    </Wizard>
  )
}
